export const markCommunicationAsRead = async (
    communicationId: string,
    config: any,
    token: string | undefined,
    employerId: string,
    employeeId: string
) => {
    const response = await fetch(`${config?.API_URL}/communications/${communicationId}/read`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            employerId: employerId,
            employeeId: employeeId
        })
    })

    if(!response.ok) {
        throw new Error("Failed to mark communication as read");
    }

    return response.json();
}